import { css } from "@emotion/react";
import { media } from "styles/breakpoints";
import { theme } from "styles/theme";

export const TimeLineStyle = {
  blockCalendar: css`
    display: flex;
    gap: 8px;
  `,
  buttonCalendar: (isSelect: boolean) => css`
    padding: 10px 32px;
    border-radius: 999px;
    margin-top: 16px;
    font-size: 14px;
    font-weight: ${isSelect ? 600 : 500};
    color: ${isSelect ? theme.colors.darkGreen : theme.colors.lightText};
    background: ${isSelect ? "rgba(255, 219, 36, 0.12)" : "transparent"};
    border: 1px solid
      ${isSelect ? theme.borders.primary : "rgba(244, 215, 147, 0.25)"};
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      color: ${theme.colors.darkGreen};
      border-color: ${theme.borders.primary};
      background: rgba(255, 219, 36, 0.08);
    }
  `,
  fromGroupContainer: () => css`
    display: flex;
    gap: 8px;
    align-items: center;
    margin: 16px 0;

    ${media.sm} {
      flex-wrap: wrap;
      gap: 0;
      /* justify-content: center; */
      justify-content: space-between;
    }
  `,
  formGroup: () => css`
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-width: 160px;
    width: calc(20% - 8px);

    ${media.xl} {
      width: calc(50% - 8px);
    }
  `,
  spanDate: (colorContent: string) => css`
    color: ${colorContent};
  `,
  iconCalendar: () => css`
    color: ${theme.colors.darkGreen};
  `,
  fromDash: () => css`
    display: flex;
    flex-direction: column;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    gap: 8px;
    span {
      &:first-of-type {
        color: transparent;
      }
      color: ${theme.colors.darkGreen};
    }

    ${media.md} {
      color: ${theme.colors.darkGreen};
    }
    ${media.sm} {
      color: ${theme.colors.darkGreen};
    }
  `,
  formSubmit: css`
    display: flex;
    flex-direction: column;
    text-align: center;
    margin-left: 8px;
    gap: 8px;
    ${media.sm} {
      margin-left: 0;
      margin-top: 16px;
      width: 100%;
    }
  `,
  blockEmpty: () => css`
    color: transparent;
  `,
  btnSubmit: () => css`
    min-width: 120px;
    height: 44px !important;
    border-radius: 999px !important;
    font-weight: 700 !important;
    letter-spacing: 0.4px;
    background: ${theme.colors.gradient[1]} !important;
    color: ${theme.colors.black} !important;
    border: none !important;
    box-shadow: 0 6px 16px rgba(233, 168, 17, 0.35),
      inset 0 1px 0 rgba(255, 255, 255, 0.4) !important;
    transition: all 0.25s ease !important;

    &:not(:disabled):hover,
    &:not(:disabled):focus {
      background: ${theme.colors.gradient[1]} !important;
      color: ${theme.colors.black} !important;
      transform: translateY(-2px);
      box-shadow: 0 10px 22px rgba(233, 168, 17, 0.5),
        inset 0 1px 0 rgba(255, 255, 255, 0.5) !important;
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    ${media.sm} {
      min-width: 0;
      width: 100%;
    }
  `,
};
